import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Loader, Text } from '@mantine/core'
import { usePage } from '@inertiajs/react'

export default function TeamsAuthStart({ editing }) {
  const { t } = useTranslation()
  const { csrf_token } = usePage().props
  const form = useRef(null)
  const started = useRef(false)
  useEffect(() => {
    if (started.current) return
    started.current = true
    form.current.requestSubmit()
  }, [])
  return <Container size="xs" py="xl"><Loader size="sm"/><Text mt="md">{t("Microsoft-aanmelding openen…")}</Text><form ref={form} action="/auth/microsoft?teams_popup=1" method="post">{editing && <input type="hidden" name="editing" value="1"/>}<input type="hidden" name="authenticity_token" value={csrf_token}/></form></Container>
}
